"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAuthParams = void 0;
var hasAuthParams = function (location) {
    if (location === void 0) { location = window.location; }
    // response_mode: query
    var searchParams = new URLSearchParams(location.search);
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) {
        return true;
    }
    // response_mode: fragment
    searchParams = new URLSearchParams(location.hash.replace("#", "?"));
    if ((searchParams.get("code") || searchParams.get("error")) && searchParams.get("state")) {
        return true;
    }
    return false;
};
exports.hasAuthParams = hasAuthParams;
